import { render, staticRenderFns } from "./ActiveGoodsCard.vue?vue&type=template&id=74ea9180"
import script from "./ActiveGoodsCard.vue?vue&type=script&lang=js"
export * from "./ActiveGoodsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports